import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';
import { branding } from '../data/mock';

const Hero = () => {
  const { t } = useLanguage();

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1580725869538-9b164c27c44f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxib3JhJTIwYm9yYXxlbnwwfHx8fDE3NzYwNjkxNjB8MA&ixlib=rb-4.1.0&q=85"
          alt="Bora Bora"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0077FF]/70 via-[#0077FF]/50 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center text-white">
        <div className="max-w-4xl mx-auto space-y-6 animate-fade-in">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <div className="bg-white/95 backdrop-blur-md p-4 md:p-6 rounded-3xl shadow-2xl max-w-[280px] md:max-w-none">
              <img 
                src={branding.logo} 
                alt="CleanRide Rental Logo" 
                className="h-20 md:h-32 w-auto"
              />
            </div>
          </div>

          <h1 className="text-4xl md:text-7xl font-bold mb-3 md:mb-4 drop-shadow-2xl">
            {t.hero.title}
          </h1>
          
          <p className="text-xl md:text-3xl font-semibold mb-3 md:mb-4 drop-shadow-lg">
            {t.hero.subtitle}
          </p>
          
          <p className="text-lg md:text-2xl italic mb-6 md:mb-8 text-white/95 drop-shadow-lg font-light">
            {t.hero.tagline}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8 md:mb-0">
            <Button 
              onClick={scrollToContact}
              size="lg"
              className="bg-[#FF8C00] hover:bg-[#FF7700] text-white font-bold px-10 py-7 text-xl md:text-lg shadow-2xl hover:shadow-3xl hover:scale-105 transition-all duration-300 border-2 border-white/30 w-full sm:w-auto"
            >
              {t.hero.cta}
              <ArrowRight className="ml-2 w-6 h-6" />
            </Button>
          </div>

          {/* Floating Info Cards */}
          <div className="grid grid-cols-3 gap-2 md:gap-4 mt-12 md:mt-16 max-w-3xl mx-auto px-2">
            <div className="bg-white/10 backdrop-blur-md rounded-xl md:rounded-2xl p-3 md:p-6 border border-white/20 shadow-xl hover:bg-white/20 transition-all duration-300 hover:scale-105">
              <div className="text-2xl md:text-4xl font-bold text-[#FF8C00]">5K</div>
              <div className="text-xs md:text-sm font-medium">XPF / 24h</div>
              <div className="text-xs opacity-90 hidden md:block">E-Scooter</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-xl md:rounded-2xl p-3 md:p-6 border border-white/20 shadow-xl hover:bg-white/20 transition-all duration-300 hover:scale-105">
              <div className="text-2xl md:text-4xl font-bold text-[#FF8C00]">10K</div>
              <div className="text-xs md:text-sm font-medium">XPF / 24h</div>
              <div className="text-xs opacity-90 hidden md:block">E-Moto</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-xl md:rounded-2xl p-3 md:p-6 border border-white/20 shadow-xl hover:bg-white/20 transition-all duration-300 hover:scale-105">
              <div className="text-2xl md:text-4xl font-bold text-[#FF8C00]">15K</div>
              <div className="text-xs md:text-sm font-medium">XPF / 24h</div>
              <div className="text-xs opacity-90 hidden md:block">Buggy</div>
            </div>
          </div>

          {/* Promotion Badge */}
          <div className="inline-block bg-gradient-to-r from-[#FF8C00] to-[#FF6B35] text-white px-6 py-3 rounded-full font-bold shadow-2xl mt-8 animate-pulse">
            🎁 Promotion : 4 jours + 1 gratuit
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
